import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

const urls = {
  createPrelistProductService: '/product/createPrelistProduct',
  getPrelistProductDetails: '/product/prelistProduct-detail',
  searchPrelistProductPaginated: '/product/searchPrelistProduct_paginated',
  createProductFromPrelist: '/product/createProductFromPrelist',
  updatePrelistProductImages: '/product/uploadPrelistProductImages',
  updatePrelistProduct: '/product/updatePrelistProduct',
  updateProductStatus: '/product/updateProductStatus'
};

export const createPrelistProductServiceApi = createAsyncThunk(
  'serviceplug/createPrelistProductServiceApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.createPrelistProductService}`,
        method: 'post',
        data: params
      });
      const data = await response.data;
      return data?.result;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const deletePrelistProductServiceApi = createAsyncThunk(
  'serviceplug/deletePrelistProductServiceApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.createPrelistProductService}/${params.productId}`,
        method: 'delete'
      });
      const data = await response.data;
      return data?.result;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getPrelistProductAndServiceDetailsApi = createAsyncThunk(
  'serviceplug/getPrelistProductAndServiceDetailsApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(`${urls.getPrelistProductDetails}/${params.productId}`);
      if (response.data?.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getPrelistProductPaginatedApi = createAsyncThunk(
  'serviceplug/getPrelistProductPaginatedApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.post(urls.searchPrelistProductPaginated, params);
      if (response.data?.result) {
        return {
          result: response.data?.result,
          isAppend: params.isAppend,
          hasMoreStoreData: _.isArray(response.data?.result) && response.data?.result?.length > 9
        };
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const createProductFromPrelistApi = createAsyncThunk(
  'serviceplug/createProductFromPrelistApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.createProductFromPrelist}`,
        method: 'post',
        data: params
      });
      const data = await response.data;
      return data?.result;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const uploadPrelistProductImagesApi = createAsyncThunk(
  'user/uploadPrelistProductImagesApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.updatePrelistProductImages}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const updatePrelistProductApi = createAsyncThunk('serviceplug/updateProduct', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updatePrelistProduct}/${params._id}`,
      method: 'put',
      data: params
    });
    const data = await response.data;

    return data?.result;
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const updateProductStatusApi = createAsyncThunk('serviceplug/updateProductStatus', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateProductStatus}`,
      method: 'post',
      data: params
    });
    const data = await response.data?.result;
    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});
